import ReactPixel from "react-facebook-pixel";

export function load() {
    return ReactPixel;
}
